import React from "react";
import {FiBookmark} from "react-icons/fi";
import {RoundTripFlight} from "../../models/RoundTripFlight";
import {itineraryKey, useShortlistStore} from "../../store/useShortlistStore";
import {useTranslation} from "../../i18n/LanguageProvider";

const Bookmark = FiBookmark as unknown as React.FC<{size?: number; fill?: string}>;

export default function BookmarkFlightButton({flight}: {flight: RoundTripFlight}) {
  const {t} = useTranslation();
  const saved = useShortlistStore(state => state.flights.some(item => itineraryKey(item) === itineraryKey(flight)));
  const busy = useShortlistStore(state => state.busy);
  const toggle = useShortlistStore(state => state.toggle);
  return <button type="button" aria-label={t(saved ? "shortlist.remove" : "shortlist.save")}
    title={t(saved ? "shortlist.saved" : "shortlist.save")} aria-pressed={saved} disabled={busy}
    onClick={event => {event.stopPropagation(); void toggle(flight);}}
    className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[#DED5F8] text-[#712FFF] transition hover:bg-[#EDE5FF] disabled:opacity-50 ${saved ? "bg-[#EDE5FF]" : "bg-white"}`}>
    <Bookmark size={19} fill={saved ? "currentColor" : "none"}/>
  </button>;
}
